import { IconName } from './ui.schemas';

type IconProps = {
  name: IconName;
};

export function Icon({ name }: IconProps) {
  const common = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (name) {
    case 'shield':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M12 3.5 19 6v5.6c0 4.2-2.8 7.6-7 8.9-4.2-1.3-7-4.7-7-8.9V6l7-2.5Z" stroke="currentColor" strokeWidth="1.7" />
          <path d="m9.3 12 1.8 1.8 3.9-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'zap':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M13 2.8 5.7 13h5.6L10.6 21l7.5-10.4h-5.7L13 2.8Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
        </svg>
      );
    case 'device':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M7 4.5h10A2.5 2.5 0 0 1 19.5 7v10A2.5 2.5 0 0 1 17 19.5H7A2.5 2.5 0 0 1 4.5 17V7A2.5 2.5 0 0 1 7 4.5Z" stroke="currentColor" strokeWidth="1.7" />
          <path d="M8 15.5h8M9 8.5h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'lock':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M7 10V8a5 5 0 0 1 10 0v2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          <path d="M6.5 10h11v8.5h-11V10Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="M12 14v1.8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'server':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M5 5.5h14v5H5v-5ZM5 13.5h14v5H5v-5Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="M8 8h.01M8 16h.01M12 8h4M12 16h4" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        </svg>
      );
    case 'gift':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M4.5 9h15v10h-15V9ZM3.8 6.5h16.4V9H3.8V6.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="M12 6.5V19M9.2 6.5C7 6.5 6.4 4 8.1 3.4c1.5-.5 2.8 1.2 3.9 3.1 1.1-1.9 2.4-3.6 3.9-3.1 1.7.6 1.1 3.1-1.1 3.1" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'users':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M9.5 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3.5 19c.7-3 2.8-4.6 6-4.6s5.3 1.6 6 4.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          <path d="M16 12.3a3 3 0 0 0 .2-5.8M16.8 14.6c2 .5 3.2 2 3.7 4.4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'phone':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M8 3.5h8A1.5 1.5 0 0 1 17.5 5v14A1.5 1.5 0 0 1 16 20.5H8A1.5 1.5 0 0 1 6.5 19V5A1.5 1.5 0 0 1 8 3.5Z" stroke="currentColor" strokeWidth="1.7" />
          <path d="M10.5 17.5h3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'monitor':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M4 5h16v10.5H4V5ZM9 20h6M12 15.5V20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'linux':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M8 18.5h8M7.5 15.5c.2-4.8 1.3-9.9 4.5-9.9s4.3 5.1 4.5 9.9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          <path d="M9 11h6M9.5 15.5h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'arrow':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M5 12h13M13 7l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'menu':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case 'check':
      return (
        <svg {...common} aria-hidden="true">
          <path d="m5 12 4 4 10-10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'wifi':
      return (
        <svg {...common} aria-hidden="true">
          <path d="M4.5 9a11.5 11.5 0 0 1 15 0M8 12.5a6.2 6.2 0 0 1 8 0M11.2 16.1a1.3 1.3 0 0 1 1.6 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
  }
}
